import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import CustomerProfileForm from '@/features/pos/components/CustomerProfile/form/Provider'
import Content from '@/features/pos/components/CustomerProfile/parts/Content'
import { CustomerLookupSaveInput } from '@/features/pos/components/CustomerProfile/types'
import { isAddressRequired } from '@/features/pos/components/CustomerProfile/utils'
import { transformCustomerToProfileFormDefaultValues } from '@/features/pos/components/CustomerProfile/utils/transforms'
import { CustomerInput } from '@/features/pos/components/OrderFinalization/form/types'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'

interface CustomerProfileProps {
    deliveryTypeCategories: DeliveryTypeCategory[]
    deliveryTypeCategory: DeliveryTypeCategory
    initialCustomer?: CustomerInput
    onCancel: () => void
    onSave: (input: CustomerLookupSaveInput) => void
}

const CustomerProfile: FC<CustomerProfileProps> = ({
    deliveryTypeCategories,
    deliveryTypeCategory,
    initialCustomer,
    onCancel,
    onSave,
}) => {
    const fallbackDeliveryTypeCategory = deliveryTypeCategories[0] ?? deliveryTypeCategory
    const resetDeliveryTypeCategory = deliveryTypeCategories.includes(deliveryTypeCategory)
        ? deliveryTypeCategory
        : fallbackDeliveryTypeCategory
    const [draftDeliveryTypeCategory, setDraftDeliveryTypeCategory] =
        useState(resetDeliveryTypeCategory)

    useEffect(() => {
        if (deliveryTypeCategories.includes(draftDeliveryTypeCategory)) return

        setDraftDeliveryTypeCategory(fallbackDeliveryTypeCategory)
    }, [deliveryTypeCategories, draftDeliveryTypeCategory, fallbackDeliveryTypeCategory])

    const defaultValues = useMemo(
        () => transformCustomerToProfileFormDefaultValues(initialCustomer),
        [initialCustomer]
    )

    const handleResetDeliveryTypeCategory = useCallback(
        () => setDraftDeliveryTypeCategory(resetDeliveryTypeCategory),
        [resetDeliveryTypeCategory]
    )

    return (
        <CustomerProfileForm
            defaultValues={defaultValues}
            isDelivery={isAddressRequired(draftDeliveryTypeCategory)}
        >
            <Content
                deliveryTypeCategories={deliveryTypeCategories}
                draftDeliveryTypeCategory={draftDeliveryTypeCategory}
                initialCustomer={initialCustomer}
                onCancel={onCancel}
                onDraftDeliveryTypeCategoryChange={setDraftDeliveryTypeCategory}
                onResetDeliveryTypeCategory={handleResetDeliveryTypeCategory}
                onSave={onSave}
            />
        </CustomerProfileForm>
    )
}

export default CustomerProfile
